/* 
MODIFICATION PROVIDED BY SEARCHANISE SUPPORT TEAM. WITH ANY QUESTIONS, CONTACT US AT feedback@searchanise.io

Modification adds the filtering options to the top of the collection pages. 
The modification only displays the options that match the results. 

You can modify the list of the options in the Settings section below. 
The options are storred in the filtersList variable. The variable content is put between curly braces. 

Each filter option should be represented with the following information: 
1. The exact name of the filter where the option is found (case-sensitive).
2. The exact name of the option (case-sensitive).
3. The name of the option that will be displayed for the user, may differ from the original option name.

! Filter and option names should be written in German.

To avoid repetative entries, the filter options are organized under the filter name, so one filter holds several options. 

Here is the structure of the filtersList variable: 

let filtersList = {
    "First filter name (1)": {
        "Option Name (2)": "Option display name (3)",
        "Option Name (2)": "Option display name (3)",
    },
    "Second filter name (1)": {
        "Option Name (2)": "Option display name (3)",
    },
}

Here are the formatting rules you should follow to make sure the code works as expected: 
1. Put all text you add (filter names, option names) in double quote marks.
2. End each line inside the filtersList variable with a comma, except for the opening curly braces.

Aside from the filtersList variable, you can also find the isEnabled variable below. 
By default, it is set to true. In case you need to disable the modification, change it to false, so it looks like that: 

let isEnabled = false;

*/ 

// SETTINGS START

let filtersList = {
    "Kategorie": {
        "Grosse Teppiche": "Grössere",
        "Kleine Teppiche": "Kleinere",
        "Outdoor": "Outdoor",
    },
    "Stil": {
        "Einfarbig": "Einfarbige",
        "Modern": "Moderne",
    },
    "Farbe": {
        "Mehrfarbig": "Bunte",
    },
    "Form": {
        "Läufer": "Läufer",
        "Rund": "Runde",
        "Oval": "Ovale",
    },
}

let isEnabled = true;

// SETTINGS END, DO NOT MODIFY THE CODE BELOW

document.addEventListener('Searchanise.Loaded', function() {
    (function($) {

        if (!isEnabled || isEnabled === 'false') { return }

        if (!window.location.href.includes('/collections/')) { return }

        let allFilters;
        let filterNameToIndex = {};

        function translateToTargetLanguage() {
            if ($('html').attr('lang') == 'de') { return }

            let currentCollection = Searchanise.GetWidgets().searchResults.getPrevData().params.collection;

            Searchanise.GetWidgets().processRequest(Searchanise.GetWidgets().paths.request_url, {
                apiKey: Searchanise.ApiKey, 
                collection: currentCollection,
                facets: true
            }, function(data) {
                let filtersInDe = data && data.facets ? data.facets : false;

                let filtersToBeAdded = findFiltersToBeAdded(filtersInDe);
                if (!filtersToBeAdded) { return }

                let originalToTranslatedFilterNames = mapOriginalToTranslatedFilterNames(allFilters, filtersToBeAdded);
                let originalToTranslatedOptionNames = mapOriginalToTranslatedOptionNames(filtersInDe, filtersToBeAdded, originalToTranslatedFilterNames);
                
                addCustomOptions(originalToTranslatedOptionNames);
            });
        }

        function mapOriginalToTranslatedFilterNames(allFilters, filtersToBeAdded) {
            let filtersToBeAddedEntries = Object.entries(filtersToBeAdded);
            let allFiltersEntries = Object.entries(allFilters);

            let originalToTranslatedFilterNames = {};

            for (let i = 0; i < Object.keys(filtersToBeAdded).length; i++) {
                let requiredAttribute = filtersToBeAddedEntries[i][1].attribute;
                for (let j = 0; j < Object.keys(allFilters).length; j++) {
                    if (requiredAttribute == allFiltersEntries[j][1].attribute) {
                        originalToTranslatedFilterNames[Object.keys(filtersToBeAdded)[i]] = Object.keys(allFilters)[j];
                        break;
                    }
                }
            }
          
            return Object.keys(originalToTranslatedFilterNames) ? originalToTranslatedFilterNames : false;
        }

        function mapOriginalToTranslatedOptionNames(filtersInDe, filtersToBeAdded, originalToTargetFilterName) {
            let optionsToBeAddedInDe = findOptionsToBeAdded(filtersToBeAdded);
            if (!Object.keys(optionsToBeAddedInDe).length) { return }
            
            let translatedOptionsToBeAdded = {}
                
            let optionsToBeAddedInDeEntries = Object.entries(optionsToBeAddedInDe)
            for (let i = 0; i < optionsToBeAddedInDeEntries.length; i++) {
                let translatedFilter = allFilters[originalToTargetFilterName[optionsToBeAddedInDeEntries[i][1].filterName]];
                let translatedOption = translatedFilter.buckets[Object.entries(optionsToBeAddedInDe)[i][1].index];
                translatedOptionsToBeAdded[translatedOption.value] = {filterName: translatedFilter.title, displayName: translatedOption.value, filterAttr: translatedFilter.attribute};
            }
            
            return Object.keys(translatedOptionsToBeAdded).length ? translatedOptionsToBeAdded : false;
        }

        function mapFilterNameToIndex(filterName, filtersObject) {
            let filtersValues = Object.values(filtersObject);
            for (let i = 0; i < filtersValues.length; i++) {
                if (filtersValues[i]) {
                    filterNameToIndex[filtersValues[i].title] = i;
                }
            }

            return Object.keys(filterNameToIndex).length ? filterNameToIndex[filterName] : false;
        }

        function mapOptionNameToIndex(filtersToBeAdded, filterName) {
            let optionNameToIndex = {};
            let filterValues = Object.values(filtersToBeAdded[filterName].buckets);
            for (let i = 0; i < filterValues.length; i++ ) {
                optionNameToIndex[filterValues[i].value] = i;
            }

            return Object.keys(optionNameToIndex).length ? optionNameToIndex  : false;
        }

        function findFiltersToBeAdded(filtersObject) {
            let filtersToBeAdded = {};

            let filtersListEntries = Object.entries(filtersList);
            
            for (let i = 0; i < Object.keys(filtersList).length; i++) {
                let filterIndex = mapFilterNameToIndex(filtersListEntries[i][0], filtersObject);
                if (filterIndex && filtersObject[filterIndex]) {
                    filtersToBeAdded[filtersListEntries[i][0]] = (filtersObject[filterIndex]);
                }
            }
            
            return Object.keys(filtersToBeAdded).length ? filtersToBeAdded : false;
        }

        function findOptionsToBeAdded(filtersToBeAdded) {
            let optionsToBeAdded = {};

            for (let filter of Object.keys(filtersToBeAdded)) {
                let requiredOptions = filtersList[filter];
                let availableOptions = filtersToBeAdded[filter].buckets;
                
                let optionNameToIndex = mapOptionNameToIndex(filtersToBeAdded, filter);

                for (let option of Object.keys(requiredOptions)) {
                    if (availableOptions[optionNameToIndex[option]] && availableOptions[optionNameToIndex[option]].count != 0) {
                        optionsToBeAdded[option] = {filterName: filter, displayName: filtersList[filter][option], index: optionNameToIndex[option], filterAttr: filtersToBeAdded[filter].attribute};
                    }
                }
            }

            return Object.keys(optionsToBeAdded).length ? optionsToBeAdded : false;
        }

        function addCustomOptions(optionsToBeAdded) {
            let optionsEntry = Object.entries(optionsToBeAdded);
            if ($('.snize-custom-filter').children().length) {
                $('.snize-custom-filter').empty();
            }
            for (let i = 0; i < optionsEntry.length; i++) {
                let optionName = optionsEntry[i][0];
                let optionDisplayName = optionsEntry[i][1].displayName;
                let filterName = optionsEntry[i][1].filterName;
                let filterAttr = optionsEntry[i][1].filterAttr;
                $('.snize-custom-filter').append(`<div class="snize-custom-filter__option" data-filter="${filterName}" data-option="${optionName}" data-filter-attr="${filterAttr}" aria-label="Filter by ${filterName}, ${optionDisplayName}" tabindex="0" role="button">${optionDisplayName} <svg class="snize-custom-reset-filter-button" aria-hidden="true" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.82253 0.183542C7.58589 -0.0530905 7.20364 -0.0530905 6.96701 0.183542L4 3.14448L1.03299 0.177474C0.79636 -0.0591581 0.414107 -0.0591581 0.177474 0.177474C-0.0591581 0.414107 -0.0591581 0.79636 0.177474 1.03299L3.14448 4L0.177474 6.96701C-0.0591581 7.20364 -0.0591581 7.58589 0.177474 7.82253C0.414107 8.05916 0.79636 8.05916 1.03299 7.82253L4 4.85552L6.96701 7.82253C7.20364 8.05916 7.58589 8.05916 7.82253 7.82253C8.05916 7.58589 8.05916 7.20364 7.82253 6.96701L4.85552 4L7.82253 1.03299C8.05309 0.802427 8.05309 0.414107 7.82253 0.183542Z" fill="#FFFFFF"></path></svg></div>`);
                
                let restrictEntries = Object.entries(Searchanise.GetWidgets().searchResults.getPrevData().params.restrictBy);
                for (let restrictEntry of restrictEntries) {
                    if (restrictEntry[0] == filterAttr && restrictEntry[1].includes(optionName)) {
                        $(`.snize-custom-filter__option[data-filter="${filterName}"][data-option="${optionName}"]`).addClass('snize-custom-option-selected').attr('aria-label', `Remove filter ${filterName}, ${optionDisplayName}`);
                    }
                }
            }

            $(`.snize-custom-filter__option`).off('click keydown').on('click keydown', function(e) {
                console.dir(e);
                if (e.type == 'keydown' && e.key != 'Enter') { return }
                let filterAttr = e.currentTarget.getAttribute('data-filter-attr');
                let optionValue = e.currentTarget.getAttribute('data-option')
                if (e.currentTarget.classList.contains('snize-custom-option-selected')) {
                    $(`.snize-selected-filters [data-se-facet-attribute="${filterAttr}"][data-se-facet-value="${optionValue}"]`).trigger('click');
                } else {
                    let prevRestrict = Searchanise.GetWidgets().searchResults.getPrevData().params.restrictBy;
                    if (prevRestrict[filterAttr]) {
                        prevRestrict[filterAttr] = prevRestrict[filterAttr] + `|${optionValue}`;
                    } else {
                        prevRestrict[filterAttr] = optionValue;
                    }
                    Searchanise.GetWidgets().searchResults.search({
                        restrictBy: {...prevRestrict}
                    });
                }   
            })
        }

        function addCustomFilter(container) {
            if (!$('.snize-custom-filter', container).length) {
                let anchorEl = window.innerWidth > 820 ? '.snize-horizontal-wrapper' : '.snize-main-panel';
                $(anchorEl, container).before(`<div class="snize-custom-filter"></div>`);
            } else if ($('.snize-custom-filter', container).children().length) {
                $('.snize-custom-filter', container).empty();
            }
            
            let optionsToBeAdded;

            if ($('html').attr('lang') != 'de') {
                translateToTargetLanguage();
            } else {
                let filtersToBeAdded = findFiltersToBeAdded(allFilters);
                if (!filtersToBeAdded) { return }
    
                optionsToBeAdded = findOptionsToBeAdded(filtersToBeAdded);
                if (!optionsToBeAdded) { return }
    
                addCustomOptions(optionsToBeAdded);
            }
        }

        $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
            if (type == 'results' && data && data.facets && data.facets.length && params && window.location.href.includes(params.collection)) {
                allFilters = data.facets;
            }
        });

        $(document).on('Searchanise.ResultsUpdated', function(event, container) {
            addCustomFilter(container);
        });
    })(window.Searchanise.$);
});